export const state = {
  dateConfigTime: {
    disableMobile: false,
    altInput: true,
    altFormat: 'd.m.Y H:i',
    dateFormat: 'Y-m-d H:i:S',
    enableTime: true,
    time_24hr: true,
    allowInput: true,
    minuteIncrement: 15,
    locale: {
      firstDayOfWeek: 1,
    },
  },
  dateConfig: {
    disableMobile: false,
    altInput: true,
    altFormat: 'd.m.Y',
    dateFormat: 'Y-m-d H:i:S',
    allowInput: true,
    minuteIncrement: 15,
    locale: {
      firstDayOfWeek: 1,
    },
  },
  dateOnlyConfig: {
    disableMobile: false,
    altInput: true,
    altFormat: 'd.m.Y',
    dateFormat: 'Y-m-d',
    allowInput: true,
    locale: {
      firstDayOfWeek: 1,
    },
  },
  timeConfig: {
    disableMobile: false,
    altInput: true,
    enableTime: true,
    noCalendar: true,
    altFormat: 'H:i',
    dateFormat: 'H:i:S',
    time_24hr: true,
    allowInput: true,
    minuteIncrement: 15,
    defaultDate: '00:00:00',
    locale: {
      firstDayOfWeek: 1,
    },
  },
  currentReportStatus: 1,
  allowanceTypes: {
    meals: 'Verpflegung',
    overnight_stay: 'Übernachtung',
    ride_costs: 'Fahrtkosten',
  },
  meals: {
    complete: 'Komplette Verpflegung',
    meals_minus_breakfast: 'Verpflegung abzgl. Frühstück (-20%)',
    meals_minus_lunch: 'Verpflegung abzgl. Mittagessen (-40%)',
    meals_minus_dinner: 'Verpflegung abzgl. Abendessen (-40%)',
    meals_minus_breakfast_and_lunch: 'Verpflegung abzgl. Frühstück & Mittagessen (-60%)',
    meals_minus_breakfast_and_dinner: 'Verpflegung abzgl. Frühstück & Abendessen (-60%)',
    meals_minus_lunch_and_dinner: 'Verpflegung abzgl. Mittagessen & Abendessen (-80%)',
  },
};

export const mutations = {
  REPORT_STATUS(state, status) {
    state.currentReportStatus = status;
  },
};

export const actions = {
  updateCurrentReportStatus({ commit }, status) {
    commit('REPORT_STATUS', status);
  },
};
